import TextField from '@eversports/react-components/primitives/TextField'
import Text from '@eversports/react-components/primitives/Text'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { AddOnField as AddOnFieldType, SelectAddOnFieldSelectionType } from '../../../typings/AdditionalInformation'

import { useIntl } from '../../../localization/react'
import MultiSelectionField from './MultiSelectionField'
import SingleSelectionField from './SingleSelectionField'

interface Props {
  field: AddOnFieldType
  mandatory: boolean
}

const AddOnField: React.FC<React.PropsWithChildren<Props>> = ({ field, mandatory = false }) => {
  const intl = useIntl()

  switch (field.__typename) {
    case 'TextAddOnField':
      return (
        <>
          <Text size="small">{field.description}</Text>
          <TextField name={field.id} placeholder={intl.textAddOnPlaceholder()} required={mandatory} fullWidth />
        </>
      )
    case 'NumberAddOnField':
      return (
        <>
          <Text size="small">{field.description}</Text>
          <TextField
            id="number"
            type="number"
            placeholder={intl.numberAddOnPlaceholder()}
            name={field.id}
            inputProps={{ min: 0 }}
            required={mandatory}
            fullWidth
          />
        </>
      )
    case 'SelectAddOnField':
      if (field.selectionType === SelectAddOnFieldSelectionType.SELECTION_TYPE_SINGLE) {
        return <SingleSelectionField {...field} mandatory={mandatory} />
      }
      return <MultiSelectionField {...field} />
    default:
      return assertNever(field)
  }
}

export default AddOnField
